/* eslint-disable react/prop-types */
// import {format} from 'date-fns';
import { Link } from "react-router-dom";
import { ColumnFilter } from "./ColumnFilter";
import { ColumnFilterReadOnly } from "./ColumnFilterReadOnly";
import { ColumnFilterBoolean } from "./ColumnFilterBoolean";
export const COLUMNS = [
  {
    Header: "First Name",
    accessor: "owner.firstName",
    Filter: ColumnFilter,
  },
  {
    Header: "Last Name",
    accessor: "owner.lastName",
    Filter: ColumnFilter,
  },
  {
    Header: "Restaurant",
    accessor: "nameRes",
    // Cell: '',
    Filter: ColumnFilter,
  },
  {
    Header: "Address",
    accessor: "address",
    Filter: ColumnFilter,
  },
  {
    Header: "Phone",
    accessor: "phone",
    Filter: ColumnFilter,
  },

  {
    Header: "Archive",
    accessor: "archive",
    Filter: ColumnFilterBoolean,
    Cell: ({ row }) => (
      <div className="d-flex justify-content-center">
        {row?.original?.archive ? (
          <Link className="btn btn-danger btn-sm me-2">
              Stand By
          </Link>
        ) : (
          <Link className="btn btn-success btn-sm me-2">
              In Work
          </Link>
        )}
      </div>
    ),
  },
  {
    Header: "Actions",
    Footer: "Actions",
    accessor: "actions",
    Filter: ColumnFilterReadOnly,
    Cell: ({ row }) => (
      <div className="d-flex justify-content-center">
        <Link
          to={`/${row?.original?.nameRes}`}
          className="btn btn-primary btn-sm me-2"
        >
          <i className="fas fa-eye"></i>
        </Link>
      </div>
    ),
  },
];

export const GROUPED_COLUMNS = [
  {
    Header: "Id",
    Footer: "Id",
    accessor: "id",
  },
  {
    Header: "Name",
    Footer: "Name",
    columns: [
      {
        Header: "First Name",
        Footer: "First Name",
        accessor: "first_name",
      },
      {
        Header: "Last Name",
        Footer: "Last Name",
        accessor: "last_name",
      },
    ],
  },
  {
    Header: "Info",
    Footer: "Info",
    columns: [
      {
        Header: "Date of  Birth",
        Footer: "Date of  Birth",
        accessor: "date_of_birth",
      },
      {
        Header: "Country",
        Footer: "Country",
        accessor: "country",
      },
      {
        Header: "Phone",
        Footer: "Phone",
        accessor: "phone",
      },
    ],
  },
];
